export default {
    nav: {
        home: '首页',
        contact: '联系方式',
        about: '关于我们',
        join: '人才招聘',
        dataService: '数据服务'
    },
    button: {
        login: '会员登录',
        logout: '退出',
        openLogin: '打开登录窗口'
    },
    message: {
        loginRequired: '请先登录',
        loginStatusChanged: '导航栏监听到登录状态变化:',
        debugJumpTo: '[调试] 跳转至:',
        eventBusError: '事件总线未注册，请在main.js中添加: Vue.prototype.$bus = new Vue()'
    },
    footer: {
        about: '关于我们',
        philosophy: '公司理念',
        contact: '联系方式',
        careers: '人才招聘',
        copyright: 'Copyright © 2009-2098 www.meituodata.com All Rights Reserved.',
        icp: '浙ICP备20027945号-1',
        phone: '联系电话：18969418571(微信同号)',
        address: '地址：杭州市西湖区古墩路387号金桂大厦1406室'
    },
    el: {
        pagination: {
            total: '总计 {total}',
            goto: '跳转'
        }
    },
    home_page:{
        item_data: "数据",
        items: "条",
        export: "导出",
        export_page: "当前页",
        export_all: "全部记录",
        export_last_time: "数据更新至",
        advanced_search: "高级搜索",
        advanced_search_add: "添加筛选条件",
        advanced_search_condition: "搜索条件",
        advanced_search_button: "搜索",
        advanced_search_loading: "数据加载中"
    },
    index: {
        banner: {
            title: "专注医药信息服务",
            content: "10多年行业经验，专业数据支持。全球展会参与 CPHI、API、CAC、FIC等国际展会。专业数据分析 真实有效、真诚专业的市场咨询。专业数据服务 真实有效、真诚专业的市场咨询。",
            images: [
                "/img/bg1.jpg", // 实验室场景图
                "/img/bg2.jpg", // 医药展会现场
                "/img/bg3.jpg"  // 数据分析图表
            ]
        },
        company: {
            name: "杭州美拓医药科技有限公司",
            intro: "坐落于美丽西子湖畔杭州的医药信息公司，专注、专业从事医药、农药、生物、化工等信息数据服务。为广大国内外客户提供真实有效、真诚专业的数据信息和市场咨询。",
            experience: "公司专注医药化工行业10多年，和国内绝大部分医药出口企业建立良好联系与合作，常年参加CPHI、API、CAC、FIC等展会。"
        },
        services: {
            title: "核心服务",
            data: {
                title: "数据信息服务",
                desc: "提供医药、农药、生物、化工等行业的专业数据信息，助力客户决策"
            },
            consulting: {
                title: "市场咨询",
                desc: "真诚专业的市场分析与咨询服务，为企业发展提供战略支持"
            },
            cooperation: {
                title: "企业合作对接",
                desc: "连接国内外医药企业，促进技术交流与商业合作"
            },
            exhibition: {
                title: "展会服务",
                desc: "提供国际展会参展支持，拓展企业全球视野"
            }
        },
        exhibitions: {
            title: "国际展会参与",
            cphi: {
                name: "CPHI 全球医药原料展",
                desc: "全球领先的医药原料及制药设备展览会"
            },
            api: {
                name: "API China 中国国际原料药展",
                desc: "中国制药原料行业的盛会"
            },
            cac: {
                name: "CAC 中国国际农用化学品及植保展览会",
                desc: "全球领先的农用化学品专业展览会"
            },
            fic: {
                name: "FIC 中国国际食品添加剂和配料展览会",
                desc: "亚洲领先的食品添加剂和配料专业展会"
            }
        },
        clients: {
            title: "合作客户",
            desc: "与国内绝大部分医药出口企业建立良好联系与合作",
            list: ["客户企业 A", "客户企业 B", "客户企业 C", "客户企业 D", "客户企业 E", "客户企业 F"]
        },
        contact: {
            title: "联系我们"
        }
    },
    lang: {
        'zh-CN': '中文',
        'en-US': '英文'
    }
};